import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";

function PublicRoutes({ children }) {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <React.Fragment>
            {children}
            <Outlet />
        </React.Fragment>
    );
}

export default PublicRoutes;
